__turbopack_context__.v({
  "checkbox": "ProductItem-module-scss-module__Xg3meW__checkbox",
  "close-icon": "ProductItem-module-scss-module__Xg3meW__close-icon",
  "content-container": "ProductItem-module-scss-module__Xg3meW__content-container",
  "image": "ProductItem-module-scss-module__Xg3meW__image",
  "image-container": "ProductItem-module-scss-module__Xg3meW__image-container",
  "image-inner-container": "ProductItem-module-scss-module__Xg3meW__image-inner-container",
  "image-inner-container-small": "ProductItem-module-scss-module__Xg3meW__image-inner-container-small",
  "money-back": "ProductItem-module-scss-module__Xg3meW__money-back",
  "money-back-negative": "ProductItem-module-scss-module__Xg3meW__money-back-negative",
  "name-chip-container": "ProductItem-module-scss-module__Xg3meW__name-chip-container",
  "price": "ProductItem-module-scss-module__Xg3meW__price",
  "product-chip": "ProductItem-module-scss-module__Xg3meW__product-chip",
  "product-chip-bottom-right-thingy": "ProductItem-module-scss-module__Xg3meW__product-chip-bottom-right-thingy",
  "product-chip-close": "ProductItem-module-scss-module__Xg3meW__product-chip-close",
  "product-chip-on-close-only": "ProductItem-module-scss-module__Xg3meW__product-chip-on-close-only",
  "product-chip-top-left-thingy": "ProductItem-module-scss-module__Xg3meW__product-chip-top-left-thingy",
  "product-close": "ProductItem-module-scss-module__Xg3meW__product-close",
  "product-item": "ProductItem-module-scss-module__Xg3meW__product-item",
  "product-item-clickable": "ProductItem-module-scss-module__Xg3meW__product-item-clickable",
  "product-item-has-new-values": "ProductItem-module-scss-module__Xg3meW__product-item-has-new-values",
  "product-name": "ProductItem-module-scss-module__Xg3meW__product-name",
  "product-variant": "ProductItem-module-scss-module__Xg3meW__product-variant",
  "product-variant-key": "ProductItem-module-scss-module__Xg3meW__product-variant-key",
  "product-variant-value": "ProductItem-module-scss-module__Xg3meW__product-variant-value",
  "product-variant-value-exchange": "ProductItem-module-scss-module__Xg3meW__product-variant-value-exchange",
  "product-variant-value-replaced": "ProductItem-module-scss-module__Xg3meW__product-variant-value-replaced",
  "product-variants": "ProductItem-module-scss-module__Xg3meW__product-variants",
  "products-cost-wrapper": "ProductItem-module-scss-module__Xg3meW__products-cost-wrapper",
  "subtitle": "ProductItem-module-scss-module__Xg3meW__subtitle",
  "text-underline": "ProductItem-module-scss-module__Xg3meW__text-underline",
  "thingy-brand": "ProductItem-module-scss-module__Xg3meW__thingy-brand",
  "tight": "ProductItem-module-scss-module__Xg3meW__tight",
});
